import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { ComponentBase, T4DataSource } from 't4core';
import { RequestDetails, ServiceRequestStatus } from 't4core';
import { T4_FindIssueDialog } from '../../dialogs/findIssueDialog/findIssueDialog';
import { T4_ServiceDialog } from '../../dialogs/serviceDialog/serviceDialog';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { T4DatatableWidget } from '../../../../t4common';



@Component({
    selector: 'serviceOverview',
    templateUrl: './Service.html',
    styleUrls: ['./Service.css']
})
export class ServiceComponent extends ComponentBase implements OnInit {
    @Input() public isOneWay: boolean = false;

    @ViewChildren(MatSort) ctrlSorters: QueryList<MatSort>;
    @ViewChildren(MatPaginator) ctrlPagers: QueryList<MatPaginator>;

    @ViewChildren(T4DatatableWidget) ctrlTables: QueryList<T4DatatableWidget>;

    private sorters: MatSort[] = [];
    private pagers: MatPaginator[] = [];

    public txtFilter: FormControl = new FormControl();

  tblAllColumns = ['userId', 'RequestNo', 'CreatedAt', 'RentalObject', 'Type','Description'];
  tblFeaturedColumns = ['userId', 'RequestNo', 'EstimatedDate', 'Status', 'RentalObject','Type','RentalLocation', 'ServiceLocation'];
  tblNewColumns = ['userId', 'RequestNo', 'CreatedAt', 'RentalObject', 'Type','RentalLocation', 'Description'];
  tblActiveColumns = ['userId', 'RequestNo', 'EstimatedDate', 'Status', 'RentalObject', 'Type','RentalLocation', 'ServiceLocation'];
  tblExpiredColumns = ['userId', 'RequestNo', 'RentalObject', 'Type','RentalLocation', 'ServiceLocation'];
  tblMissingColumns = ['userId', 'RequestNo', 'RentalObject', 'Type','CreatedAt', 'RentalLocation']; 

    constructor(private router: Router, private route: ActivatedRoute, el: ElementRef) {
        super();

        this.txtFilter.valueChanges.pipe(debounceTime(150))
            .subscribe(() => {
                if (this.featuredRequests) this.featuredRequests.filter = this.txtFilter.value;
                if (this.newRequests) this.newRequests.filter = this.txtFilter.value;
                if (this.activeRequests) this.activeRequests.filter = this.txtFilter.value;
                if (this.expiredRequests) this.expiredRequests.filter = this.txtFilter.value;


              this.ctrlTables.forEach(x => x.data.filter = this.txtFilter.value);
            });
  }

    async ngOnInit() {
      console.log("table controls", this.ctrlTables);
      await this.loadRequests();

      // For specific transforms in export
      //var transform = {
      //    Customer: x  => x.Customer.Name
      //  };
      //  this.ctrlTables.map(x => x.exportTransformations = transform);
    }

    // Data
    private requests: RequestDetails[] = [];

  // ViewModel
    public allRequests: any[];
    public newRequests = [];
    public featuredRequests = [];
    public activeRequests = [];
    public expiredRequests =  [];
    public missingRequests = [];

    public urgentRequests = [];
    public handledRequests = [];


    // Event handlers
    public FindIssue() {
        this.Dialog.open(T4_FindIssueDialog).afterClosed().toPromise().then((x: RequestDetails) => {
            if (x) {
                this.Dialog.open(T4_ServiceDialog, { data: { requestId: x.Id } }).afterClosed().toPromise().then((x: any) => { });
            }
        });
    }

    // Data functions
  private async loadRequests() {
    var token = this.UI.beginLoading('Turbo.OneWayAdmin.Service.msgLoadingRequest', 'Loading service requests', null);

    this.requests = await this.Api.get<RequestDetails[]>('/Service/GetActiveRequests', { oneway: this.isOneWay, IsInsurance: false });

    this.sorters = this.ctrlSorters.toArray();
    this.pagers = this.ctrlPagers.toArray();

    this.populateDatasources();

    if (this.Settings.isInAny(['OneWayAdmin'])) {
      this.sorters[0].sort({ id: "EstimatedDate", start: "asc", disableClear: false });
      this.sorters[1].sort({ id: "CreatedAt", start: "asc", disableClear: false });
      this.sorters[2].sort({ id: "EstimatedDate", start: "asc", disableClear: false });
      this.sorters[3].sort({ id: "RentalObject", start: "asc", disableClear: false });
      this.sorters[4].sort({ id: "CreatedAt", start: "desc", disableClear: false });
      this.sorters[5].sort({ id: "CreatedAt", start: "asc", disableClear: false });
    } else {
      this.sorters[0].sort({ id: "CreatedAt", start: "asc", disableClear: false });
    }

    this.UI.loaderCompleted(token);
  }

  private populateDatasources() {
      this.featuredRequests = this.requests.slice().filter(x => !x.Tags || x.Tags.indexOf("Saknas") < 0).filter(x => x.Status! >= ServiceRequestStatus.Received && x.Status! < ServiceRequestStatus.Completed && x.Status! != ServiceRequestStatus.Expired && x.ExpectedResolveDate! <= this.tomorrow);
      this.activeRequests = this.requests.slice().filter(x => !x.Tags || x.Tags.indexOf("Saknas") < 0).filter(x => x.Status! >= ServiceRequestStatus.Received && x.Status! < ServiceRequestStatus.Completed && x.Status! != ServiceRequestStatus.Expired && x.ExpectedResolveDate! > this.tomorrow);
      this.expiredRequests = this.requests.slice().filter(x => !x.Tags || x.Tags.indexOf("Saknas") < 0).filter(x => x.Status! == ServiceRequestStatus.Expired);
      this.missingRequests = this.requests.slice().filter(x => x.Tags && x.Tags.indexOf("Saknas") >= 0);

      this.newRequests = this.requests.slice().
        filter(x => !x.Tags || x.Tags.indexOf("Saknas") < 0).
        filter(x => x.Status == ServiceRequestStatus.New);

    this.allRequests = this.requests; 

    this.ctrlTables.forEach(x => x.update());
  }

    private updateRequest(id: string) {
        var token = this.UI.beginLoading('Turbo.OneWayAdmin.Service.msgLoadingRequest', 'Loading service requests', null);

        this.Api.get<RequestDetails>('/Service/GetRequest', { id: id }).then(x => {
            var item = this.requests.find(y => y.Id == x.Id);
            if (!item) return;

            if (x.Status! >= ServiceRequestStatus.Completed) this.requests.splice(this.requests.indexOf(item), 1);
            else if (x.Status! < ServiceRequestStatus.Completed) this.requests[this.requests.indexOf(item)] = x; 
            else if (x.Status! < ServiceRequestStatus.Completed) this.requests.push(x);

            this.populateDatasources();

            // Set filter
            if (this.featuredRequests) this.featuredRequests.filter = this.txtFilter.value;
            if (this.newRequests) this.newRequests.filter = this.txtFilter.value;
            if (this.activeRequests) this.activeRequests.filter = this.txtFilter.value;
            if (this.expiredRequests) this.expiredRequests.filter = this.txtFilter.value;

          this.ctrlTables.forEach(x => x.data.filter = this.txtFilter.value);

            this.UI.loaderCompleted(token);
        });
    }

    public showDetails(id: string) {
        this.Dialog.open(T4_ServiceDialog, { data: { requestId: id } }).afterClosed().toPromise().then((x: any) => {
            this.updateRequest(id);
        });
    }

    public export(data: T4DataSource) {
        data.export();
    }

    private assembleSearchString(item: RequestDetails): string {
        var searchStr = item.RequestNo + "|";
        if (item.RentalObject) {
            if (item.RentalObject.RentalLocation) {
                searchStr += item.RentalObject.RentalLocation!.Name + "|";
                searchStr += item.RentalObject.RentalLocation!.LocationCode + "|";
            }
            searchStr += item.RentalObject.Title + "|";
            searchStr += item.RentalObject.Alias + "|";
            searchStr += item.Status + "|";
            searchStr += item.Description + "|";
        }
        if (item.Tags) {
            for (var i = 0; i < item.Tags.length; i++) {
                searchStr += "|" + item.Tags[i];
            }
        }
        if (item.ServiceLocation) searchStr += item.ServiceLocation!.Name;

        return searchStr;
    }
}
